import { WidgetLayout } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';
import ConferenceEvents from '@/_shared/images/icons/megaphone.svg?react';

export function Layout({
  children,
  className,
  fallback,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
}) {
  return (
    <WidgetLayout
      title={dashboardWidgetsPermissionConfig['upcoming_conferences_events'].name}
      icon={ConferenceEvents}
      viewAllLink="/conferences-and-events"
      viewAllText="View All Conferences & Events"
      className={className}
      fallback={fallback}
      bodyClassName="3xl:pr-1 pr-0.5"
      descriptionClassName="max-h-[480px] pr-4 overflow-y-auto"
    >
      {children}
    </WidgetLayout>
  );
}
